import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './login.css';


const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      window.location.href = '/'; // Rediriger après connexion
    } catch (err) {
      setError('Échec de la connexion. Vérifiez vos identifiants.');
    }
  };

  return (
    <div className='login-page'>
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Se connecter</h2>
        {error && <p className="error-message">{error}</p>}
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          placeholder="Email" 
          required 
          className="input-field"
        />
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          placeholder="Mot de passe" 
          required 
          className="input-field"
        />
        <button type="submit" className="submit-button">Connexion</button>
      </form>
    </div>
    </div>
  );
};

export default Login;
